import { render, staticRenderFns } from "./ChallengesCard.vue?vue&type=template&id=5fac0f46&scoped=true"
import script from "./ChallengesCard.vue?vue&type=script&lang=js"
export * from "./ChallengesCard.vue?vue&type=script&lang=js"
import style0 from "./ChallengesCard.vue?vue&type=style&index=0&id=5fac0f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fac0f46",
  null
  
)

export default component.exports